/**
 * Frontend runtime configuration.
 *
 * In production the SPA and the API share an origin behind Caddy, so the
 * defaults (relative URLs) work without any build-time substitution. The
 * Vite dev server proxies /api to TEST. Keycloak uses the TEST origin
 * directly in local dev so browser cookies and Keycloak's generated form
 * actions stay on the same host during the login flow.
 *
 * If we ever deploy the SPA to a different origin (e.g. a CDN), a
 * `window.__EMS_RUNTIME_CONFIG__` injected before bundle load will take
 * precedence over these defaults. No rebuild required.
 */

type RuntimeConfig = {
  apiBaseUrl: string;
  keycloakBaseUrl: string;
  keycloakRealm: string;
  keycloakClientId: string;
};

declare global {
  // eslint-disable-next-line no-var
  var __EMS_RUNTIME_CONFIG__: Partial<RuntimeConfig> | undefined;
}

const devBackend = (import.meta.env.VITE_DEV_BACKEND ?? "https://ems-test.inoitech.eu").replace(
  /\/+$/u,
  "",
);

const defaults: RuntimeConfig = {
  apiBaseUrl: "/api",
  keycloakBaseUrl: import.meta.env.DEV ? `${devBackend}/auth` : "/auth",
  keycloakRealm: "ems",
  keycloakClientId: "ems-web",
};

const runtime = (globalThis.__EMS_RUNTIME_CONFIG__ ?? {}) as Partial<RuntimeConfig>;

export const config: RuntimeConfig = {
  apiBaseUrl: runtime.apiBaseUrl ?? defaults.apiBaseUrl,
  keycloakBaseUrl: runtime.keycloakBaseUrl ?? defaults.keycloakBaseUrl,
  keycloakRealm: runtime.keycloakRealm ?? defaults.keycloakRealm,
  keycloakClientId: runtime.keycloakClientId ?? defaults.keycloakClientId,
};
